export default __webpack_public_path__ + "page-builder-styles/froala-show-blocks.css";